import { ChecklistDocumentStyles } from "../model/documentStyles";

export const defaultDocumentStyles: ChecklistDocumentStyles = {
  checklistDocument: {
    padding: "20pt",
    fontFamily: "Inter",
    backgroundColor: "#fff",
  },
  checklistDocumentTitle: {
    textAlign: "center",
    backgroundColor: "#000",
    color: "#fff",
    marginBottom: "5pt",
    padding: "4pt 2pt 3pt",
    fontSize: "20pt",
    fontWeight: 600,
    lineHeight: 1.15,
    width: "100%",
  },
  checklistDocumentBody: {
    display: "flex",
    flex: 1,
    flexDirection: "column",
    flexWrap: "wrap",
    alignContent: "space-between",
    justifyContent: "flex-start",
  },
  checklist: {
    border: "1pt solid #000",
    marginBottom: "5pt",
  },
  checklistTitle: {
    fontSize: "14pt",
    textAlign: "center",
    backgroundColor: "#000",
    color: "#fff",
    paddingTop: "3pt",
    paddingBottom: "3pt",
    lineHeight: 1.15,
  },
  checklistBody: {
    paddingTop: "2pt",
    paddingBottom: "2pt",
    paddingLeft: "0pt",
    paddingRight: "0pt",
  },
  checklistHeader: {
    marginTop: "5pt",
    fontSize: "12pt",
    textAlign: "center",
    textDecoration: "underline",
    marginBottom: "5pt",
    lineHeight: 1.15,
    padding: "0px 1px",
    flex: "0 0 auto",
    backgroundColor: "#fff",
    color: "#000",
  },
  checklistItem: {
    fontSize: "12pt",
    display: "flex",
    flexDirection: "row",
    flexWrap: "nowrap",
    alignItems: "flex-start",
    justifyContent: "space-between",
    marginTop: "0pt",
    marginBottom: "0pt",
    paddingTop: "1pt",
    paddingBottom: "1pt",
    lineHeight: 1.15,
    paddingLeft: "2pt",
    paddingRight: "2pt",
    backgroundColor: "#fff",
    color: "#000",
  },
  checklistItemLabel: {
    textAlign: "left",
    alignItems: "flex-start",
    flexShrink: 0,
    flexGrow: 100,
    lineHeight: 1.15,
  },
  checklistItemSeparatorText: {
    overflow: "hidden",
    textOverflow: undefined,
    flexShrink: 100,
    flexGrow: 0,
    marginLeft: "1pt",
    marginRight: "1pt",
    lineHeight: 1.15,
    fontWeight: 400,
  },
  checklistItemSetting: {
    textAlign: "right",
    alignItems: "flex-end",
    flexShrink: 0,
    flexGrow: 100,
    lineHeight: 1.15,
  },
  simOnlyWarning: {
    textAlign: "center",
    fontSize: "10pt",
    color: "#fff",
    backgroundColor: "#000",
    width: "80%",
    margin: "0 auto",
  },
  attributionText: {
    fontSize: "7pt",
  },
};
